import React from "react";
import "./CtaSection.css";
// Importing the image name provided as requested
import ctaBgImage from "../assets3/washing-machine-repair.jpg"; 

const CtaSection = () => {
  return (
    <section 
      className="jabh-cta-section"
      style={{ backgroundImage: `url(${ctaBgImage})` }}
    >
      <div className="jabh-cta-overlay">
        <div className="jabh-cta-container">
          
          {/* Left Text Block */}
          <div className="jabh-cta-text-content">
            <h2 className="jabh-cta-heading">Schedule Your Service Today</h2>
            <p className="jabh-cta-description">
              Enjoy quick and dependable washing machine repair at your doorstep. 
              Contact us now for skilled technicians, honest transparent pricing, 
              and expert same-day service for all machine models.
            </p>
          </div>

          {/* Right Action Button */}
          <div className="jabh-cta-action">
            <a href="tel:+917317596984" className="jabh-cta-btn">
              73175 96984
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CtaSection;